import React, { useEffect, useState } from "react";
import CustomTitle from "./title";
import { Box, Typography } from "@mui/material";
import { Styles } from "./styles";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";

const Stats = ({uniqueVisitors, site_visits,panelCount,serviceCount}) => {
  const sentences = [`You can show the search result and more details`,`Just Purchase the service which you want`];
  const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sentences.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Styles>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "30px",
            width:"100%"
        }}
      >
        <Box
          sx={{ display: "flex", flexDirection: "row" ,width:"100%"}}
          className="description"
        >
          <Typography
            className="main-description"
            sx={{
              color: "#000000",
              fontWeight: "600",
              width: "100%",
                justifyContent: "center",
              lineHeight: "32px",
              display: "flex",
              alignItems: "center",
              fontFamily: "Instrument_Sans",
              fontSize: {
                xs: "16px",
                sm: "20px",
                md: "26px",
              },
            }}
          >
            {/*Your Smart Gateway to&nbsp;*/}
            <span className="dynamic-container-visit">
              {sentences.map((sentence, index) => (
                <span
                  key={index}
                  style={{cursor:'pointer'}}
                  onClick={() => navigate("/OurServices")}
                  className={`visit ${
                    currentIndex === index ? "visible" : ""
                  }`}
                >
                  {sentence}
                </span>
              ))}
            </span>
          </Typography>

        </Box>

      </Box>
    </Styles>
  );
};

export default Stats;
